// extracted by mini-css-extract-plugin
module.exports = {"input":"Paginator-input-NvrEi","disabled":"Paginator-disabled-1njjE","action":"Paginator-action-ZujLk"};